import { render, staticRenderFns } from "./create-new-agent.vue?vue&type=template&id=40417e89&scoped=true&"
import script from "./create-new-agent.vue?vue&type=script&lang=ts&"
export * from "./create-new-agent.vue?vue&type=script&lang=ts&"
import style0 from "./create-new-agent.vue?vue&type=style&index=0&id=40417e89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40417e89",
  null
  
)

export default component.exports